// import L from 'leaflet';
import MarkerCluster from 'leaflet.markercluster';
import arrow from '../../images/arrow-long.png';

export default function initializeMap() {
    document.querySelectorAll('#map').forEach(function (mapDom) {
        new MapInitializer(mapDom);
    });
}

class MapInitializer {
    params = {};
    preloaderDOM = null;

    constructor(mapDom) {
        this.mapDom = mapDom;
        this.block = document.querySelector( '.block-map-osm' );
        this.listDOM = this.block.querySelector( '.block-map-osm__list' );
        this.preloaderDOM = this.block.querySelector( '.block-map-osm__loader' );
        this.params.lang = this.block.getAttribute('data-lang');
        this.baseHref = window.location;
        this.markers = null;
        this.map = null;
        this.init();
    }

    init() {
        if (!this.mapDom) {
            return;
        }

        this.initMap();
        this.loadMarkers();
        this.initSearch();
        this.loadObjects();
    }

    initMap() {
        const osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 });
        const cities = L.layerGroup();
        this.markers = L.markerClusterGroup();

        const isPC = !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

        this.map = L.map(this.mapDom, {
            center: [52.234982, 21.008490],
            zoom: 7,
            scrollWheelZoom: false,
            dragging: isPC,
            layers: [osm, cities],
            zoomControl: false
        });

        new L.Control.Zoom({ position: 'topright' }).addTo(this.map);

        L.Map.addInitHook(function() {
            return L.DomEvent.off(this._container, 'mousedown', this.keyboard._onMouseDown);
        });
    }

    async loadMarkers() {
        const data = await this.fetchData();
        data.results.forEach(result => {
            result.posts.forEach(post => {
                const marker = this.createMarker(post.fields.map.lat, post.fields.map.lng, result.taxonomy.marker, post);
                this.markers.addLayer(marker);
            });
        });
        this.map.addLayer(this.markers);
    }

    async fetchData() {
        const lang = this.mapDom?.dataset.lang || 'pl';
        const url = `${window.location.origin}/wp-json/epp/v1/object/?lang=${lang}`;
        const response = await fetch(url);
        return response.json();
    }

    createMarker(lat, lng, markerIcon, data) {
        const icon = L.icon({
            iconUrl: markerIcon,
            iconSize: [24, 32],
            iconAnchor: [12, 32],
            popupAnchor: [0, -30]
        });

        const newMarker = L.marker([lat, lng], { icon });

        const more = this.mapDom?.dataset.more || 'More';
        const customPopup = `
            <div class='block-map-osm__popup'>
                <div class='block-map-osm__popup__thumbnail'>
                    <img style='width: 300px; height: auto; max-height: 300px; min-height: 200px; margin-bottom: 20px;' src='${data.thumbnail}'>
                </div>
                <div class='block-map-osm__list__title'>${data.title}</div>
                <a href='${data.permalink}' class='block-map-osm__popup__more'>${more}</a>
            </div>`;

        newMarker.bindPopup(customPopup, { maxWidth: 400, minHeight: 400, className: 'popupCustom' }).openPopup();

        this.map.on('popupopen', (e) => {
            const px = this.map.project(e.target._popup._latlng);
            px.y -= e.target._popup._container.clientHeight / 2;
            this.map.panTo(this.map.unproject(px), { animate: true });
        });

        return newMarker;
    }

    initSearch() {

        const search = document.querySelector('.search-page__form__form');


        search.addEventListener('submit', (e) => {
            e.preventDefault();
            this.params = {
                lang: this.params.lang,
                search: search.querySelector('.search-page__form__field').value
            };
            this.loadObjects(true);

            setTimeout(() => {
                search.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        });

    }

    loadObjects(clear) {
        this.preloader( true );

        if (clear == true){
            this.listDOM.innerHTML = '';
        }

        let xhr = new XMLHttpRequest();
        xhr.open( 'GET', this.baseHref.origin + '/wp-json/epp/v1/object/twig/?params=' + JSON.stringify( this.params ) );
        xhr.send();
        xhr.onload = function() {
            if (xhr.status != 200) {
                console.error( `Error ${xhr.status}: ${xhr.statusText}` );
            } else {
                try {
                    this.listDOM.innerHTML += JSON.parse( xhr.responseText );
                } catch (e) {
                    console.error(e);
                }
                setTimeout( function() {
                    this.preloader( false );
                    this.block.querySelector( '.block-map-osm__loader' ).scrollIntoView();
                }.bind( this ), 25 );
            }
        }.bind( this );
        xhr.onerror = function() {
            console.log( 'Request failed' );
        };
    }

    preloader( status ) {
        if (status === false) {
            this.preloaderDOM.classList.add( 'd-none' );
            this.listDOM.classList.add( 'ready' );
        } else {
            this.preloaderDOM.classList.remove( 'd-none' );
            this.listDOM.classList.add( 'loading' );
        }
    }

}
